import { render, staticRenderFns } from "./PressInspection.vue?vue&type=template&id=8f986788&"
import script from "./PressInspection.vue?vue&type=script&lang=js&"
export * from "./PressInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports